import { ApiError } from "./types";

export type MfaStepUpErrorDetail = {
  code: "mfa_step_up_required";
  message: string;
  organization_id?: number;
  enforcement_at?: string;
  reason?: string;
};

function detailFromPayload(payload: unknown): MfaStepUpErrorDetail | null {
  if (!payload || typeof payload !== "object" || !("detail" in payload)) {
    return null;
  }

  const detail = (payload as { detail?: unknown }).detail;
  if (
    detail &&
    typeof detail === "object" &&
    "code" in detail &&
    (detail as { code?: unknown }).code === "mfa_step_up_required" &&
    "message" in detail &&
    typeof (detail as { message?: unknown }).message === "string"
  ) {
    const context = detail as Record<string, unknown>;
    return {
      code: "mfa_step_up_required",
      message: (detail as { message: string }).message,
      ...(typeof context.organization_id === "number" ? { organization_id: context.organization_id } : {}),
      ...(typeof context.enforcement_at === "string" ? { enforcement_at: context.enforcement_at } : {}),
      ...(typeof context.reason === "string" ? { reason: context.reason } : {}),
    };
  }

  return null;
}

/** Recognizes structured mfa_step_up_required across compose, analysis-ui, and fetch wrappers. */
export function parseMfaStepUpError(error: unknown): MfaStepUpErrorDetail | null {
  if (!error || typeof error !== "object") {
    return null;
  }

  if (error instanceof ApiError && error.details) {
    const fromDetails = detailFromPayload(error.details);
    if (fromDetails) {
      return fromDetails;
    }
  }

  const body = "body" in error ? (error as { body?: unknown }).body : error;
  return detailFromPayload(body);
}
